import { Controller } from "stimulus"

export default class extends Controller {
  
  static targets = ["parentCategory", "subcategories", "searchInput"];

  toggleSubcategories() {
   this.subcategoriesTarget.classList.toggle("hidden");
  }

  selectParentCategory(e) {
      
    if (this.hasSubcategoriesTarget) {
      var subCategoriesCheckboxes = this.subcategoriesTarget.querySelectorAll("input[type=checkbox]");
      if (e.target.checked) {
        this.subcategoriesTarget.classList.remove("hidden");
        subCategoriesCheckboxes.forEach((checkbox) => { checkbox.checked = true })
      } else {
        this.subcategoriesTarget.classList.add("hidden");
        subCategoriesCheckboxes.forEach((checkbox) => { checkbox.checked = false })
      }
    }
  }

  selectSubcategory(e) {
    if (e.target.checked) {
      this.element.querySelector("input[type=checkbox]").checked = true
    }
  }


}
